export const casinoNews = [
  {
    id: 1,
    title: 'Новые мобильные казино онлайн 2026: обзор лучших приложений',
    date: '15 января 2026',
    excerpt: 'В начале 2026 года на рынке появились новые мобильные казино с улучшенной оптимизацией и эксклюзивными бонусами для игроков из России.',
    image: 'https://public.readdy.ai/ai/img_res/ff940c6bedbceab7043b64054b65f3ae.jpg',
    category: 'Новости'
  },
  {
    id: 2,
    title: 'СБП в онлайн казино: мгновенные переводы без комиссии',
    date: '12 января 2026',
    excerpt: 'Система быстрых платежей становится самым популярным методом пополнения в российских онлайн казино благодаря скорости и безопасности.',
    image: 'https://readdy.ai/api/search-image?query=digital%20payment%20system%20illustration%20with%20russian%20ruble%20symbols%20and%20instant%20transfer%20icons%20on%20gradient%20blue%20background%2C%20financial%20technology%20concept%2C%20modern%20clean%20design%2C%20professional%20vector%20style&width=600&height=400&seq=10&orientation=landscape',
    category: 'Платежи'
  },
  {
    id: 3,
    title: 'Топ-10 слотов с максимальным RTP в мобильных казино онлайн',
    date: '10 января 2026',
    excerpt: 'Эксперты Casino-Rus.Online составили рейтинг игровых автоматов с наивысшим процентом возврата для мобильных устройств.',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20slot%20machine%20reels%20with%20winning%20symbols%20and%20jackpot%20elements%20on%20dark%20background%2C%20exciting%20casino%20gaming%20atmosphere%2C%20dynamic%20colorful%20design%2C%20high%20quality%203d%20illustration&width=600&height=400&seq=11&orientation=landscape',
    category: 'Игры'
  },
  {
    id: 4,
    title: 'Живые дилеры в мобильных казино: новый уровень реализма',
    date: '8 января 2026',
    excerpt: 'Технология live-трансляций достигла нового уровня качества, позволяя играть с живыми дилерами прямо со смартфона.',
    image: 'https://readdy.ai/api/search-image?query=professional%20live%20dealer%20at%20casino%20table%20with%20cards%20and%20chips%2C%20high%20quality%20video%20streaming%20setup%2C%20elegant%20casino%20interior%2C%20cinematic%20lighting%2C%20realistic%20photography%20style&width=600&height=400&seq=12&orientation=landscape',
    category: 'Live Casino'
  },
  {
    id: 5,
    title: 'Криптовалюты в онлайн казино: анонимность и быстрые выплаты',
    date: '5 января 2026',
    excerpt: 'Все больше российских игроков выбирают криптовалюты для игры в онлайн казино из-за мгновенных транзакций и конфиденциальности.',
    image: 'https://readdy.ai/api/search-image?query=cryptocurrency%20bitcoin%20symbols%20with%20casino%20elements%20and%20digital%20wallet%20on%20futuristic%20tech%20background%2C%20blockchain%20gambling%20concept%2C%20modern%20sleek%20design%2C%20professional%20digital%20art&width=600&height=400&seq=13&orientation=landscape',
    category: 'Криптовалюты'
  }
];